<template>
  <div class="text-gray-900 dark:text-white">
    <div class="inline-flex shadow-sm w-full select-none">
      <span class="px-1 py-2 text-sm text-gray-900 bg-white border-b border-gray-200 dark:bg-zinc-950 dark:border-gray-700 dark:text-white w-full text-nowrap">تاریخ نشر: {{ blog.createdDateLocal }} </span>
      <span class="px-1 py-2 text-sm text-gray-900 bg-white border-b border-gray-200 dark:bg-zinc-950 dark:border-gray-700 dark:text-white w-full text-nowrap"> منبع: {{ blog.source }} </span>
    </div>
    <div class="inline-flex shadow-sm w-full select-none">
      <span class="px-1 py-2 text-sm text-gray-900 bg-white border-b border-gray-200 dark:bg-zinc-950 dark:border-gray-700 dark:text-white w-full text-nowrap">
        <div class="flex space-x-2 justify-end gap-2">
          <button @click="changeFontSize(-1)" class="text-gray-900 dark:text-white">
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-dash-lg w-5 h-5" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8" />
            </svg>
          </button>
          <button @click="changeFontSize(1)" class="text-gray-900 dark:text-white">
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-plus-lg w-5 h-5" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
            </svg>
          </button>
          <button @click="printBlog" class="text-gray-900 dark:text-white">
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-printer w-5 h-5" viewBox="0 0 16 16">
              <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
              <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1" />
            </svg>
          </button>
        </div>
      </span>
    </div>
    <div class="px-4 pt-4 mb-4">
      <span class="font-normal leading-none text-gray-400 dark:text-gray-500 pb-2 block" :style="{ fontSize: fontSize + 'px' }">{{ blog.headline }}</span>
      <h1 class="font-medium" :style="{ fontSize: fontSize + 'px' }">{{ blog.title }}</h1>
    </div>
    <img class="w-full my-3 cursor-pointer" v-if="blog.imageAddress" :src="blog.imageAddress" :alt="blog.title" />
    <div class="px-4">
      <p :style="{ fontSize: fontSize + 'px' }" class="bg-slate-100 dark:bg-primary/5 p-2 rounded-lg mb-3 text-justify">{{ blog.shortDescription }}</p>

      <p v-html="blog.text" class="text-justify flex flex-col gap-2" :style="{ fontSize: fontSize + 'px' }"></p>
    </div>
    <!-- <div class="inline-flex w-full select-none mt-5 mb-3">
      <span class="px-1 py-2 text-sm text-gray-900 bg-white border-b border-t border-gray-200 dark:bg-zinc-950 dark:border-gray-700 dark:text-white w-full text-nowrap">آخرین ویرایش: {{ blog.createdDateLocal }} </span>
    </div> -->
    <div class="px-4 pt-1">
      <p :style="{ fontSize: fontSize + 'px' }" class="py-2">دیدگاه خود را بنویسید:</p>
      <form class="mt-1 noprint">
        <div class="grid gap-2 mb-2 md:grid-cols-2">
          <div>
            <input v-model="form.fullName" type="text" id="first_name" class="text-sm text-gray-900 bg-white dark:bg-zinc-950 focus:ring-0 dark:text-white dark:placeholder-gray-400 dark:focus:border-transparent focus:border-gray-200 border border-gray-200 dark:border-transparent w-full rounded-lg" placeholder="نام و نام خانوادگی" required />
          </div>
          <div>
            <input v-model="form.email" type="text" id="last_name" class="text-sm text-gray-900 bg-white dark:bg-zinc-950 focus:ring-0 dark:text-white dark:placeholder-gray-400 dark:focus:border-transparent focus:border-gray-200 border border-gray-200 dark:border-transparent w-full rounded-lg" placeholder="آدرس ایمیل" required />
          </div>
        </div>
        <div class="w-full mb-4 border border-gray-200 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-none">
          <div class="px-4 py-2 bg-white rounded-t-lg dark:bg-zinc-950">
            <label for="comment" class="sr-only">نظر خود را بنویسید</label>
            <textarea v-model="form.body" id="comment" rows="4" class="resize-none w-full px-0 text-sm text-gray-900 bg-white border-0 dark:bg-zinc-950 focus:ring-0 dark:text-white dark:placeholder-gray-400" placeholder="نظر خود را بنویسید" required></textarea>
          </div>
          <div class="flex items-center justify-end px-3 py-2 bg-white dark:bg-zinc-950">
            <button v-if="!loadingBtn" @click="send" class="inline-flex items-center py-2.5 px-4 text-xs font-medium text-center text-white bg-green-500 rounded-tr-lg rounded-bl-lg hover:bg-green-800">ثبت دیدگاه</button>
            <button v-else class="inline-flex items-center py-2.5 px-4 text-xs font-medium text-center text-white bg-green-500 rounded-tr-lg rounded-bl-lg hover:bg-green-800">در حال ارسال...</button>
          </div>
        </div>
      </form>
      <p class="ms-auto text-xs text-gray-500 dark:text-gray-400 mb-5 noprint">نظر شما، پس از تایید توسط مدیران حزب رفاه ملی افغانستان، در برنامه نمایش داده خواهد شد</p>
      <p :style="{ fontSize: fontSize + 'px' }" class="py-1">نظرات دیگران:</p>
      <ul class="my-5 noprint">
        <li v-for="comment in comments" :key="comment.id">
          <div class="flex flex-col gap-1 w-full">
            <div class="flex items-center space-x-2 rtl:space-x-reverse">
              <span class="text-sm text-gray-900 dark:text-white"> {{ comment.fullName }}</span>
              <span class="text-sm font-normal text-gray-500 dark:text-gray-400"> {{ comment.createdLocal }}</span>
            </div>
            <div class="flex flex-col leading-1.5 p-4 border-gray-200 bg-gray-100 rounded-e-xl rounded-es-xl dark:bg-gray-700">
              <p class="text-sm font-normal text-gray-900 dark:text-white">{{ comment.body }}</p>
            </div>
            <span class="text-sm font-normal text-green-500">منتشر شده</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "BlogPage",
  components: {},
  data() {
    return {
      commentsList: [],
      form: {
        fullName: null,
        email: null,
        body: null,
        pageId: null,
        parentId: null,
      },
      pNumber: 1,
      fontSize: 16,
    };
  },
  computed: {
    ...mapGetters({
      blog: "baseX/blog",
      comments: "baseX/comments",
      commentsLength: "baseX/commentsLength",
      loadingBtn: "loadingBtn",
      postCheck: "postCheck",
    }),
  },
  watch: {
    postCheck() {
      if (this.postCheck) {
        this.reloadData();
        this.loadComments();
      }
    },
  },
  methods: {
    printBlog() {
      window.print();
    },
    changeFontSize(amount) {
      this.fontSize += amount;
      if (this.fontSize < 12) this.fontSize = 12;
      if (this.fontSize > 30) this.fontSize = 30;
    },
    loadComments() {
      this.$store.dispatch("baseX/getBlogComments", this.$route.params.id);
    },
    send() {
      const language = localStorage.getItem("languageId");
      let formData = new FormData();
      if (this.form.fullName) {
        formData.append("FullName", this.form.fullName);
      }
      if (this.form.email) {
        formData.append("Email", this.form.email);
      }
      if (this.form.body) {
        formData.append("Body", this.form.body);
      }
      formData.append("PageId", this.$route.params.id);
      if (language == 1) {
        this.languageParam = "fa";
      } else if (language == 2) {
        this.languageParam = "ar";
      }
      const payload = {
        language: this.languageParam,
        value: formData,
      };
      this.$store.dispatch("baseX/sendCommentBlogs", payload);
    },
    reloadData() {
      this.form = {
        fullName: null,
        email: null,
        body: null,
        pageId: null,
        parentId: null,
      };
    },
  },
  metaInfo() {
    return {
      title: this.blog.title,
    };
  },
  created() {
    const routePath = this.$route.path;
    const firstThreeLetters = routePath.slice(0, 3);
    if (firstThreeLetters === "/fa") {
      localStorage.setItem("languageId", 1);
    } else if (firstThreeLetters === "/ar") {
      localStorage.setItem("languageId", 2);
    }
  },
  beforeCreate() {
    this.$store.commit("baseX/setBlog", []);
    this.$store.dispatch("baseX/getBlog", this.$route.params.id);
  },
  mounted() {
    this.loadComments();
    this.$store.dispatch("baseX/getBlog", this.$route.params.id);
  },
};
</script>

<style scoped>
@media print {
  .noprint {
    display: none !important;
  }
}
</style>
